
















import { Component, Prop, Mixins } from "vue-property-decorator";

import { WidgetMixin, LayoutMixin } from "./mixins";

interface Area {
  name: string;
  gridColumn: string;
  gridRow: string;
}

@Component({
  components: {
    WidgetGroup: () => import("@/components/WidgetGroup.vue")
  }
})
export default class WGrid extends Mixins(WidgetMixin, LayoutMixin) {
  @Prop({ type: String, required: true })
  gridTemplateColumns?: string;

  @Prop({ type: String, required: true })
  gridTemplateRows?: string;

  @Prop({ type: Array, default: () => [] })
  areas!: Area[];

  @Prop({ type: String, default: "1rem" })
  gap?: string;

  @Prop({
    type: String,
    default: "stretch",
    validator: (value: string) =>
      ["start", "end", "center", "stretch"].includes(value)
  })
  justify!: string;

  @Prop({
    type: String,
    default: "stretch",
    validator: (value: string) =>
      ["start", "end", "center", "baseline", "stretch"].includes(value)
  })
  align!: string;

  get computedClasses() {
    return [`justify-content-${this.justify}`, `align-items-${this.align}`];
  }

  get computedStyles() {
    const { gap, gridTemplateColumns, gridTemplateRows } = this;
    return {
      display: "grid",
      gap,
      gridTemplateColumns,
      gridTemplateRows
    };
  }
}
